{
  "dismiss": "Odstranit"
}
